import React from 'react';
import logo from '../img/png/logo-text-white.png';
import {
  AiOutlineCopyrightCircle,
  AiFillLinkedin,
  AiFillFacebook,
  AiFillTwitterCircle,
  AiFillYoutube,
} from 'react-icons/ai';

function Footer() {
  const onClickFooterDocs = (link) => {
    window.location.href = link;
  };
  return (
    <>
      <footer className='footer'>
        <div className='footer_container d-flex-col'>
          {/* upper part */}
          <div className='footer_container_A d-flex'>
            {/* left */}
            <div className='footer_container_A_left flex-1'>
              <div className='content d-flex-col gap-1'>
                <img src={logo} alt='SQREEM Technologies Logo' />
                <p>
                  A pure artificial intelligence company, SQREEM Technologies is
                  also one of the world’s biggest digital behaviour aggregators.
                </p>
                <p>
                  We are a B2B marketplace for digital media buying and have
                  developed an AI solution which has solved one of the most
                  difficult challenges of the internet, by delivering
                  cookie-free, precision, Ad-targeting at scale.
                </p>
                <p>
                  • Financial Times: Asia-Pacific Fastest Growing Companies
                  2021, No. 53 <br />• The Straits Times: Singapore’s Fastest
                  Growth Companies 2021, No. 12
                </p>
              </div>
            </div>
            {/* rightt */}
            <div className='footer_container_A_right flex-1'>
              <div className='d-flex'>
                {/* Offices */}
                <div className='office d-flex-col gap-2'>
                  <p>Offices</p>
                  <div className='tripar d-flex-row justify-content-between gap-2'>
                    <div className='office_left'>
                      <p>Singapore (HQ)</p>
                      <p>
                        133 Cecil Street <br /> #15-03 Keck Seng Tower <br />
                        Singapore, 069535, SG
                      </p>
                      <p>Tokyo</p>
                      <p>
                        Tamagawa, Setagaya City 1 <br /> Chome-14-1 <br />
                        Tokyo, 158-0094, JP
                      </p>
                      <p>Ho Chi Minh City</p>
                      <p>
                        3rd Floor, Lim Tower 3<br /> 29A Nguyen Dinh Chieu
                        Street Dakao Ward, District 1
                        <br />
                        Ho Chi Minh City, Vietnam
                      </p>
                    </div>
                    <div className='office_right'>
                      <p>New York</p>
                      <p>
                        667 Madison Ave <br /> 4th and 5th Floor <br /> New
                        York, NY 10065, US
                      </p>
                      <p>Manila</p>
                      <p>
                        Unit 8-D, 8th Floor, <br /> The Ignacia Place,
                        Sgt. Esguerra Avenue, Quezon City, Philippines, 1103
                      </p>
                    </div>
                    {/* Contact */}
                    <div className='contact d-flex-col'>
                      <p>Contacts</p>
                      <p>info@sqreem.com</p>
                      <p>Careers</p>
                      <p>jobs@sqreem.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* line separator */}
          <div className='footer_container_line'></div>
          {/* buttom part */}
          <div className='footer_container_B d-flex-row justify-content-between'>
            <div className=' d-flex align-items-center'>
              <AiOutlineCopyrightCircle />
              <p>SQREEM Technologies Pte. Ltd. 2021</p>
            </div>
            <div className='terms d-flex align-items-center gap-2'>
              <p
                onClick={onClickFooterDocs.bind(
                  null,
                  'https://sqreemtech.com/gdpr-compliance/'
                )}
              >
                GDPR COMPLIANCE
              </p>

              <p
                onClick={onClickFooterDocs.bind(
                  null,
                  'https://sqreemtech.com/terms-conditions/'
                )}
              >
                TERMS & CONDITIONS
              </p>
              <p
                onClick={onClickFooterDocs.bind(
                  null,
                  'https://sqreemtech.com/terms-of-use/'
                )}
              >
                TERMS OF USE
              </p>
              <p
                onClick={onClickFooterDocs.bind(
                  null,
                  'https://sqreemtech.com/privacy/'
                )}
              >
                PRIVACY POLICY
              </p>
            </div>
            <div className='social d-flex align-items-center'>
              <p>Follow us:</p>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://www.linkedin.com/company/sqreem-technologies'
              >
                <AiFillLinkedin />
              </a>

              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://www.facebook.com/sqreemtechnologies'
              >
                <AiFillFacebook />
              </a>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://twitter.com/sqreem_ai'
              >
                <AiFillTwitterCircle />
              </a>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://www.youtube.com/channel/UCTd-LCP3G1ZmByWyEPl-b6Q/featured'
              >
                <AiFillYoutube />
              </a>
            </div>
          </div>
        </div>
        <div>
          <div className='SQREEMTechFullStackDev:JehuZubiri'></div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
